import { useQuery } from '@apollo/client';
import React from 'react';
import { SortDirection, generatedTypesNew } from '@css-xp/graphtypes';
import { fetchInvoicesForPaymentMethod } from './queries/fetch-invoices-for-payment-method';
import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';
import InvoiceTabIg from '../../../invoice-group/src/invoice-tab-ig';

interface InvoicesTableForPaymentMethodProps {
  paymentMethodId: string;
  transactionAccountId?: string;
  label?: string;
}

const sortOptions = {
  sortFields: ['createdDate', 'id'],
  sortFieldsDirections: [SortDirection.DESC, SortDirection.DESC],
};

export const InvoicesTableForPaymentMethod = ({
  paymentMethodId,
  transactionAccountId,
  label,
}: InvoicesTableForPaymentMethodProps) => {
  const { refetch, loading, error, data } = useQuery<
    generatedTypesNew.FetchInvoicesForPaymentMethodQuery,
    generatedTypesNew.FetchInvoicesForPaymentMethodQueryVariables
  >(fetchInvoicesForPaymentMethod, {
    variables: {
      id: paymentMethodId,
      searchOptions: {
        first: DEFAULT_ROWS_PER_PAGE,
        sort: { ...sortOptions },
      },
    },
    nextFetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  // variables to use for paging and populating our template
  const totalCount = data?.invoiceGroupsForPaymentMethod?.invoices?.totalCount ?? 0;
  const nodes = data?.invoiceGroupsForPaymentMethod?.invoices?.nodes;

  return (
    <InvoiceTabIg
      transactionAccountId={transactionAccountId}
      nodes={nodes}
      totalRecords={totalCount}
      loading={loading}
      error={error}
      refetch={refetch}
      label={label}
      isPaymentMethodSidebar={true}
    />
  );
};
